import React, { useState, useCallback, useMemo, useEffect, useContext } from "react";
import Card from "./Card";

//importing data
import data from "../data/data.json";

import { SavedContext } from "../App";


const Content = (props) => {
  const { saved } = useContext(SavedContext);

  return (
    <div>
      {props.results.map((item) => (
        <Card
          addSave={props.addSave}
          removeSave={props.removeSave}
          saveid={item.saveid}
          question={item.text}
          date={item.date}
          answer={item.answer}
          value={item.value}
          topic={item.topic}
          answermedia={item.answermedia}
          textmedia={item.textmedia}
          saved={saved.includes(item.saveid)}
        />
      ))}
    </div>
  );
};

export default React.memo(Content);
